import React from "react";
import PageHeading from "../../atoms/pageHeading/PageHeading";
import styles from "./homePageHeading.module.scss";
import PropTypes from "prop-types";
import {Container} from "../../atoms/DependencyHelper"
export default function HomePageHeading(props) {
	const generateAlignment=()=>{
    switch(props?.alignment){
      case "left":
      case "LEFT":{
        return props?.alignment ? 'text-left': "";
      }
      case "right":
      case "RIGHT":{
        return props?.alignment ? 'text-right': "";
      }
      default:
        return 'text-center';
      }
  }
  return (
    <Container>
      <div
        className={`${styles["home-page-heading"]} ${styles[props.className]}`}
      >
        {props.mainHeadingRequired && (
          <PageHeading
            id={props.id}
            text={props.text}
            className={`${styles["main-heading"]} ${!props.isRegularFont && props.textClassName} ${generateAlignment()} `}
          />
        )}
        {props.secondaryText && props.secondaryText !== "" && (
          <PageHeading
            id={props.id}
            text={props.secondaryText}
            className={`${styles["secondary-heading"]}  ${props.textClassName} ${styles[props.textClassName]} ${generateAlignment()} `}
          />
        )}
        {props.secondaryGreyText && props.secondaryGreyText !== "" && (
          <PageHeading
            id={props.id}
            text={props.secondaryGreyText}
            className={`${styles["secondary-heading"]} ${styles["secondary-grey-heading"]}  ${styles[props.titleType && props.titleType]} ${props.textClassName} ${generateAlignment()} `}
          />
        )}
        {props.componentDescription && (
          <PageHeading
            id={props.id}
            level={4}
            text={props.componentDescription}
            className={`${styles["description-style"]} ${generateAlignment()} `}
          />
        )}
      </div>
    </Container>
  );
}

HomePageHeading.propTypes = {
  className: PropTypes.string,
};

HomePageHeading.defaultProps = {
  className: "default"
};
